<template>
	<div>
		<div class="container-node-headline flex-column">
			<p>
				<span
					class="senaryon-icon senaryon-icon-edit-curves senaryon-icon--with-right-margin"
				></span>
				<span>
					<!-- @vue-expect-error --> {{ dataNode.data.measure_name }}</span
				>
			</p>
			<p>
				<span
					class="senaryon-icon senaryon-icon-actor-roles-research senaryon-icon--with-right-margin"
				></span>
				<span>
					<!-- @vue-expect-error --> {{ dataNode.data.modifiers_size }}</span
				>
				{{ t("activerecord.models.modifier.other") }}
				<span class="hidden-label">
					<strong>{{ t("activerecord.models.modifier.other") }}:</strong>
					<br>
					<span>
						<!-- @vue-expect-error -->
						{{ dataNode.data.modifier_targets }}</span
					>
				</span>
			</p>
		</div>
		<drawflow-top-right-tags
			:tags-to-show="tagsToShow"
			:modal-id="modalId"
			:parent-instance="this"
		></drawflow-top-right-tags>
		<drawflow-article-measure-item
			v-for="childNode in childNodes"
			v-bind:key="childNode.id"
			:data-node="childNode"
			:drawflow-instance="drawflowInstance"
		></drawflow-article-measure-item>
	</div>
</template>

<script>
import { i18n } from "../utils";
import DrawflowArticleMeasureItem from "./drawflow_article_measure_item.vue";
import DrawflowHelpers from "./drawflow_helpers";
import DrawflowTopRightTags from "./drawflow_top_right_tags.vue";

export default {
	mixins: [i18n],
	props: {
		dataNode: Object,
		drawflowInstance: Object,
		modalId: {
			type: String,
			default: "#replace-me",
		},
	},
	components: {
		"drawflow-article-measure-item": DrawflowArticleMeasureItem,
		"drawflow-top-right-tags": DrawflowTopRightTags,
	},
	computed: {
		tagsToShow() {
			// @ts-expect-error
			return this.drawflowInstance.editor_mode == "edit"
				? ["delete", "duplicate", "edit", "addArticle"]
				: [];
		},
	},
	data: function () {
		return {
			// @ts-expect-error
			childNodes: Object.values(this.dataNode.child_nodes),
		};
	},
	methods: {
		callPositionNode() {
			DrawflowHelpers.positionNode(this);
		},
		filterForArticleIds({ whitelistedArticleIds }) {
			this.childNodes.forEach((childNode) => {
				const dataDup = structuredClone(childNode.data);
				dataDup.isCollapsed =
					whitelistedArticleIds &&
					!whitelistedArticleIds.includes(String(childNode.data.article_id));
				childNode.data = dataDup;
			});
			setTimeout(() => {
				DrawflowHelpers.addToDagre(
					this.drawflowInstance,
					this.dataNode,
					this.$el.closest(".container-node"),
				);
			}, 400);
		},
	},
	mounted() {
		// pp.log("mounted drawflow_measure_item", this.dataNode, this$el);
		// @ts-expect-error
		if (this.dataNode.data.child_of) {
			pp.vue.bus.$on("DRAWFLOW-graph-changed", () => {
				setTimeout(() => {
					// Need to put this at the end of the stack so that the parent elements are positioned first
					// @ts-expect-error
					pp.vue.bus.$emit("DRAWFLOW-node-moved", { nodeId: this.dataNode.id });
				});
			});
		} else {
			setTimeout(() => {
				// Move this to the end of the stack so that the $domEl can be appended to `.container-node` in drawflow.js first
				DrawflowHelpers.addToDagre(
					this.drawflowInstance,
					this.dataNode,
					this.$el.closest(".container-node"),
				);
				pp.vue.bus.$on("DRAWFLOW-graph-changed", this.callPositionNode);
			});
		}

		pp.vue.bus.$on("DRAWFLOW-child-nodes-changed", (data) => {
			// pp.log("incoming", data, this.dataNode.id)
			// @ts-expect-error
			if (data.nodeId == this.dataNode.id) {
				// pp.log("drawflow_measure_item change", data, this);
				this.childNodes = []; // Need to destroy child Vue instances first

				this.$nextTick(() => {
					// @ts-expect-error
					this.childNodes = Object.values(this.dataNode.child_nodes);
				});
			}
		});

		pp.vue.bus.$on("DRAWFLOW-filter-article-ids", this.filterForArticleIds);
	},
	beforeDestroy() {
		pp.vue.bus.$off("DRAWFLOW-graph-changed", this.callPositionNode);
	},
};
</script>
